/**
 * Created by qingzhui on 16/12/31.
 */

require('../../scss/m/m-index.scss');

var common = require('./m-common');

var $ = require('jquery');

$(function () {
    $(window).scroll(function () {
        //检测滚走的高度
        var scrollT = $(document).scrollTop();
        //当滚走的高度>=400(天蓝色色块的上边距)，
        //显示返回顶部(.back)，否则隐藏返回顶部
        //获取蓝色色块(container)距离文档顶部的距离
        var offsetT = $("body").offset().top;
        //进行判断
        if (scrollT >offsetT) {
            $(".scoll").show()
        } else {
            $(".scoll").hide()
        }
    })
    
    //点击返回顶部，页面滚走的距离设置为0
    $(".scoll").click(function(){
        //生硬的返回
        // $(document).scrollTop(0)
        //动感的返回
        //animate({键:值},时间) 属性：scrollTop---必须是被元素调用
        $("html,body").animate({
            scrollTop:0
        },1000)
    })
    // 查看更多
    var isClick = false;

    var con1 = $('.m-business .btn-more').prev().html();

    var langInput = document.getElementById('lang');
    var lang = langInput ? langInput.value : undefined;

    var baseUrl = common.baseUrl();
    var $memberList = $('.m-leadership #list');

    // 请求的所有地址
    var ajaxUrl = {
        memberList: baseUrl + 'v1/member?lang=' + lang
    };

    
});


// WEBPACK FOOTER //
// ./src/m/m-ir.js